import I18n from 'I18n';
import { createSelector } from 'reselect';
import { createGenericOptionsSelector } from 'ContentData/helpers/reduxHelpers';
import PortalIdParser from 'PortalIdParser';
import enviro from 'enviro';
export const getWebInteractives = state => state.resources.webInteractives.webInteractives;
export const getWebInteractive = (state, props) => state.resources.webInteractives.webInteractives[props.id];
const getWebInteractivesCacheOrder = state => state.resources.webInteractives.webInteractivesCacheOrder;
export const getWebInteractiveCache = (state, props) => state.resources.webInteractives.webInteractivesCache[props.id];
export const getWebInteractivesCache = state => state.resources.webInteractives.webInteractivesCache;
export const getWebInteractiveFetchStatus = (state, props) => state.resources.webInteractives.requestStatus[props.id];
export const getWebInteractivesFetchStatus = state => state.resources.webInteractives.webInteractivesRequestStatus;
const disabledPredicate = webInteractive => webInteractive && webInteractive.isPublished && webInteractive.interactiveContainerType !== 'EMBEDDED';
const getHelpText = webInteractive => webInteractive && webInteractive.name;
export const getWebInteractiveOptions = createSelector([getWebInteractivesCache, getWebInteractivesCacheOrder], (webInteractivesCache, order) => order.reduce((hash, id) => {
  const webInteractive = webInteractivesCache[id];
  hash.push({
    value: id,
    text: webInteractive.name,
    help: I18n.text(`ContentComponents.cmv2.fields.url.linkType.help.CALL_TO_ACTION.${webInteractive.interactiveContainerType}`)
  });
  return hash;
}, []));
export const getDefaultWebInteractiveOptions = createGenericOptionsSelector(getWebInteractives, {
  disabledPredicate,
  getHelpText
});
const getWebInteractiveImageUrl = (contentId, isEmail = false) => {
  const isProd = enviro.isProd();
  const portalId = PortalIdParser.get();
  const hublet = enviro.getHublet();
  const domainSuffix = isProd ? '' : 'qa';
  const emailPath = isEmail ? 'email/' : '';
  if (hublet === 'na1') {
    return `https://cta-service-cms2.hubspot${domainSuffix}.com/web-interactives/public/v1/embed/cta-image/${emailPath}${contentId}?portalId=${portalId}`;
  }
  return `https://cta-${hublet}.hubspot${domainSuffix}.com/web-interactives/public/v1/embed/cta-image/${emailPath}${contentId}?portalId=${portalId}`;
};
function mapWebInteractiveToLegacyFormat(webInteractive, isEmail) {
  return webInteractive && {
    name: webInteractive.name,
    guid: webInteractive.id.toString(),
    ctaInfo: [{
      isDefault: true,
      image: {
        url: getWebInteractiveImageUrl(webInteractive.id, isEmail)
      }
    }]
  };
}
export const getWebInteractiveInLegacyShape = (state, props) => {
  const webInteractive = getWebInteractive(state, props);
  return mapWebInteractiveToLegacyFormat(webInteractive, props.isInEmail);
};